import React, { createContext, useContext, useState, useMemo } from 'react'
import {
  LoadingContextProps,
  LoadingContextDefaultValues,
} from '@Interfaces/Component/LoadingInterface'
import { ContextComponentProps } from '@Interfaces/Util/CommonInterface'

export const LoadingContext = createContext<LoadingContextProps>(LoadingContextDefaultValues)

export const LoadingProvider = ({ children }: ContextComponentProps) => {
  const [loading, setLoading] = useState(false)

  const contextValue = useMemo(
    () => ({
      loading,
      setLoading,
    }),
    [loading]
  )

  return <LoadingContext.Provider value={contextValue}>{children}</LoadingContext.Provider>
}

export const useLoading = (): LoadingContextProps => useContext(LoadingContext)
